// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3xabe","label":"CategoryService_label__21AaF","location":"CategoryService_location__2i58F"};